import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CountdownPipe} from './countdown.pipe';
import {OrderbyPipe} from './orderby.pipe';
import {LimittoPipe, LimittostartPipe} from './limitto.pipe';
import {FilterPipe} from './filter.pipe';
import {RoundPipe} from './round.pipe';

@NgModule({
    declarations: [CountdownPipe, RoundPipe, OrderbyPipe, LimittoPipe, LimittostartPipe, FilterPipe, RoundPipe],
    imports: [
        CommonModule
    ],
  exports: [CountdownPipe, OrderbyPipe, LimittoPipe, FilterPipe, RoundPipe, LimittostartPipe]
})
export class PipesModule {
}
